import * as React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { TimesheetReviewsStatsFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { PeriodState } from 'modules/attendance/lib/types'

interface Props {
  reviewsStats: TimesheetReviewsStatsFragment | null
}

const PeriodStatus = ({ reviewsStats }: Props) => {
  const getStatus = () => {
    switch (reviewsStats?.state) {
      case PeriodState.approved:
        return {
          type: Tag.Types.correct,
          title: i18n.t('clock_in.header.states.approved_title'),
          description: i18n.t('clock_in.header.states.approved_description'),
        }

      case PeriodState.pending:
        return {
          type: Tag.Types.accent,
          title: i18n.t('clock_in.header.states.pending_title'),
          description: i18n.t('clock_in.header.states.pending_description'),
        }

      case PeriodState.in_progress:
        return {
          type: Tag.Types.grey3,
          title: i18n.t('clock_in.header.states.in_progress_title'),
          description: i18n.t('clock_in.header.states.in_progress_description'),
        }

      default:
        return {
          type: Tag.Types.grey3,
          title: i18n.t('clock_in.header.states.in_progress_title'),
          description: i18n.t('clock_in.header.states.in_progress_description'),
        }
    }
  }

  const { title, description, type } = getStatus()

  return (
    <>
      <Box inline>
        <Text size="200" caps>
          {i18n.t('common.state')}
        </Text>
      </Box>
      <Box paddingX="s16" inline>
        <Tag type={type} upcased>
          {title}
        </Tag>
      </Box>
      <Box inline>
        <Text.Normal size="200">{description}</Text.Normal>
      </Box>
    </>
  )
}

export default PeriodStatus
